import widgetsReducer from "./reducers";

export default widgetsReducer;